// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3th7Z","messages":"Chat_messages__e2Jyp","dateDivider":"Chat_dateDivider__dNNO3"};